import { render } from "./addDepartment.vue?vue&type=template&id=383a93ee"
import script from "./addDepartment.vue?vue&type=script&lang=js"
export * from "./addDepartment.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__